import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=645837ee&scoped=true&"
import script from "./Charts.vue?vue&type=script&lang=js&"
export * from "./Charts.vue?vue&type=script&lang=js&"
import style0 from "./Charts.vue?vue&type=style&index=0&id=645837ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645837ee",
  null
  
)

export default component.exports